
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swipeStartX = 0;
        this.swipeStartY = 0;
        this.swipeInitialized = false;
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initSwipeNavigation();
      }

      hide() {
        super.hide();
      }

      initSwipeNavigation() {
        if (this.swipeInitialized) return;

        const content = this.querySelector(
          '.product-media-modal__content'
        );

        if (!content) return;

        this.swipeInitialized = true;

        content.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;

          this.swipeStartX = event.touches[0].clientX;
          this.swipeStartY = event.touches[0].clientY;
        }, { passive: true });

        content.addEventListener('touchend', (event) => {
          if (event.changedTouches.length !== 1) return;

          const deltaX =
            event.changedTouches[0].clientX - this.swipeStartX;
          const deltaY =
            event.changedTouches[0].clientY - this.swipeStartY;

          // Ignore vertical scrolling and small movements.
          if (
            Math.abs(deltaX) < 45 ||
            Math.abs(deltaX) < Math.abs(deltaY)
          ) return;

          this.changeModalImage(deltaX < 0 ? 1 : -1);
        }, { passive: true });
      }

      
      changeModalImage(direction) {
        const content = this.querySelector(
          '.product-media-modal__content'
        );

        if (!content) return;

        const images = [
          ...content.querySelectorAll('img[data-media-id]')
        ].filter((image) => {
          return !image.closest('.product-media-modal__model');
        });

        if (images.length < 2) return;

        const activeIndex = images.findIndex(
          (image) => image.classList.contains('active')
        );

        if (activeIndex === -1) return;

        const nextIndex = activeIndex + direction;

        if (nextIndex < 0 || nextIndex >= images.length) return;

        const currentImage = images[activeIndex];
        const nextImage = images[nextIndex];

        // Prevent overlapping animations.
        if (this.isAnimating) return;
        this.isAnimating = true;

        // Make the next image visible for the transition.
        nextImage.style.transition = 'none';
        nextImage.style.opacity = '0';
        nextImage.style.transform =
          `translateX(${direction * 35}px)`;

        nextImage.scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
          inline: 'center'
        });

        // Force the browser to apply the starting styles.
        nextImage.getBoundingClientRect();

        nextImage.style.transition =
          'transform 280ms ease, opacity 280ms ease';
        currentImage.style.transition =
          'transform 280ms ease, opacity 280ms ease';

        currentImage.style.transform =
          `translateX(${-direction * 35}px)`;
        currentImage.style.opacity = '0';

        nextImage.style.transform = 'translateX(0)';
        nextImage.style.opacity = '1';

        window.setTimeout(() => {
          currentImage.classList.remove('active');
          currentImage.style.transition = '';
          currentImage.style.transform = '';
          currentImage.style.opacity = '';

          nextImage.classList.add('active');
          nextImage.style.transition = '';
          nextImage.style.transform = '';
          nextImage.style.opacity = '';

          this.isAnimating = false;
        }, 300);
      }


      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(
          '[data-media-id]'
        ).forEach((element) => {
          element.classList.toggle(
            'active',
            element.getAttribute('data-media-id') === mediaId
          );
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${CSS.escape(mediaId)}"]`
        );

        if (!activeMedia) return;

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft =
            activeMedia.offsetLeft -
            (container.clientWidth - activeMedia.clientWidth) / 2;
        }

        const template = activeMedia.querySelector('template');

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          template?.content.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
